export default __webpack_public_path__ + "static/media/text-format.0a9f3605.svg";